import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '@services/environment.service';
import { HttpUtilService } from '@services/http-util.service';
import { NotificationsService } from '@services/notifications.service';
import { PageTitleService } from '@services/page-title.service';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'app-account-select',
    templateUrl: './account-select.component.html',
    styleUrls: ['./account-select.component.scss'],
    standalone: false
})
export class AccountSelectComponent implements OnInit {
  public view;
  constructor(
    private pageTitleService: PageTitleService,
    private http: HttpUtilService,
    private environmentService: EnvironmentService,
    private notification: NotificationsService,
    private httpClient: HttpClient,
    private translationService: TranslationService
  ) {}
  isDownloadingCSV = false;
  scaffoldType: string;
  ngOnInit(): void {
    this.environmentService.getInstanceDetails().subscribe(details => {
      this.scaffoldType = details.scaffoldType;
    });
    this.http
      .request(
        'get',
        `${this.environmentService.environment.apiRoot}/accounts/accounts_select?mode=read`,
        null,
        null,
        true
      )
      .subscribe(c => {
        if (c != null) {
          this.view = c;
        }
      });
    this.pageTitleService.section = 'Accounts';
  }

  exportEnrollments() {
    this.notification.popNotification('', 'Getting CSV');
    this.isDownloadingCSV = true;
    let url = `${this.environmentService.environment.apiRoot}/status/enrollments`;
    this.http.request('get', url).subscribe(response => {
      if (response.error) {
        this.isDownloadingCSV = false;
        return this.notification.popNotification(
          '',
          'Error Downloading CSV: ' + response.error
        );
      }
      if (!response?.url) {
        return this.notification.popNotification(
          '',
          'Error Downloading CSV, no url found'
        );
      }
      this.downloadBatchCSV(response?.url, response?.name);
    });
  }
  downloadBatchCSV(url, name) {
    this.httpClient
      .get(url, { responseType: 'text' })
      .subscribe((response: any) => {
        this.isDownloadingCSV = false;
        if (response.error)
          return this.notification.popNotification(
            '',
            'Error Downloading CSV File'
          );
        const blob = new Blob([response], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = name || 'batch-course-download.csv';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        return this.notification.popNotification(
          '',
          this.translationService.getTranslatedContent('downloaded_csv') +
            ': ' +
            a.download
        );
      });
  }
}
